export default "/images/3d7f8a65cf8e97dba669a531dee3e68a.avif";